import React from 'react';

import { Breadcrumb } from './Breadcrumb';
import * as S from './styles';

interface Props {
  className?: string;
  children?: React.ReactNode;
}

export function SubHeader({ className }: Props): React.ReactElement {
  return (
    <S.Wrap className={className}>
      <Breadcrumb />
    </S.Wrap>
  );
}
